// Composables
import { createRouter, createWebHistory } from "vue-router";
import { useUserStore } from "@/store/userStore";
import PageNotFound from "@/views/PageNotFound.vue";
import Welcome from "@/views/Welcome.vue";

const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/LoginUsuario.vue"),
    meta: { 
      hideFooter: false,
      public: true, // Rota pública
      title: "Login"
    },
  },
  {
    path: "/menu",
    name: "Menu",
    component: () => import("@/views/MenuTeste.vue"),
    meta: { requiresAuth: true, hideFooter: true, title: "Menu Principal" },
    children: [
      {
        path: "",
        name: "MenuDefault",
        component: Welcome,
        meta: { requiresAuth: true, hideFooter: false, title: "Bem-vindo" },
      },
      {
        path: "ConsultaMaquinasDesktop",
        name: "ConsultaMaquinasDesktop",
        component: () => import("@/views/maquinas/ConsultaMaquinas.vue"),
        meta: { requiresAuth: true, hideFooter: false, title: "Consulta Máquinas" },
      },
      {
        path: "consultaAparelhosDesktop",
        name: "consultaAparelhosDesktop",
        component: () => import("@/views/maquinas/ConsultaAparelhos.vue"),
        meta: { requiresAuth: true, hideFooter: false, title: "Consulta Aparelhos" },
      },
      {
        path: "VincularAparelhoDesktop",
        name: "VincularAparelhoDesktop",
        component: () => import("@/views/maquinas/VincularAparelhos.vue"),
        meta: { requiresAuth: true, hideFooter: false, title: "Vincular Aparelhos" },
      },
      {
        path: "ConferenciaMaquinaMapaDesktop",
        name: "ConferenciaMaquinaMapaDesktop",
        component: () => import("@/views/maquinas/ConferenciaMaquinaMapa.vue"),
        meta: { requiresAuth: true, hideFooter: false, title: "Conferência Máquina Mapa" },
      },
      {
        path: "AberturaExpedienteDesktop",
        name: "AberturaExpedienteDesktop",
        component: () => import("@/views/AberturaExpediente/AberturaExpediente.vue"),
        meta: { requiresAuth: true, hideFooter: false, title: "Abertura Expediente" },
      },
      {
        path: "AberturaExpedienteMenuDesktop",
        name: "AberturaExpedienteMenuDesktop",
        component: () => import("@/views/AberturaExpediente/MenuOpcoesExpediente.vue"),
        meta: { requiresAuth: true, hideFooter: false, title: "Menu Expediente" },
      },
      {
        path: "ConsultaChamadoDesktop",
        name: "ConsultaChamadoDesktop",
        component: () => import("@/views/aberturaChamado/ConsultaChamados.vue"),
        meta: { requiresAuth: true, hideFooter: false, title: "Consulta Chamados" },
      },
      {
        path: "AbrirChamadoDesktop",
        name: "AbrirChamadoDesktop",
        component: () => import("@/views/aberturaChamado/AbrirChamado.vue"),
        meta: { requiresAuth: true, hideFooter: false, title: "Abrir Chamado" },
      },
      {
        path: "WhatsAppConfigMobile",
        name: "WhatsAppConfigMobile",
        component: () => import("@/views/whatzap/whatzapOpcoes.vue"),
        meta: { requiresAuth: true, hideFooter: false, title: "WhatsApp Config" },
      },
      {
        path: "/CadastroPedidoMobile",
        name: "CadastroPedidoMobile",
        component: () => import("@/views/pedidos/cadastrarPedido.vue"),
        meta: { requiresAuth: true, hideFooter: false, title: "Cadastrar Pedido" },
      },
      {
        path: "/AlterarPedidoMobile/:id",
        name: "AlterarPedidoMobile",
        component: () => import("@/views/pedidos/cadastrarPedido.vue"),
        meta: { requiresAuth: true, hideFooter: false, title: "Alterar Pedido" },
      },
      {
        path: "/ConsultaPedidosMobile",
        name: "ConsultaPedidosMobile",
        component: () => import("@/views/pedidos/consultaPedidos.vue"),
        meta: { requiresAuth: true, hideFooter: false, title: "Consulta Pedidos" },
      },
      // Rotas de Administração
      {
        path: "AdministracaoExclusaoOrdens",
        name: "AdministracaoExclusaoOrdens",
        component: () => import("@/views/administracao/ExclusaoOrdens.vue"),
        meta: { 
          requiresAuth: true, 
          hideFooter: false,
          title: "Administração - Exclusão de Ordens",
          adminOnly: true
        },
      },

 // Rotas de Administração
 {
  path: "AdministracaoFinalizarOrdens",
  name: "AdministracaoFinalizarOrdens",
  component: () => import("@/views/administracao/FinalizarOrdem.vue"),
  meta: { 
    requiresAuth: true, 
    hideFooter: false,
    title: "Administração - Finalizar Ordens",
    adminOnly: true
  },
},

      {
        path: "AdministracaoUsuariosLogados",
        name: "AdministracaoUsuariosLogados",
        component: () => import("@/views/administracao/UsuariosLogados.vue"),
        meta: { 
          requiresAuth: true, 
          hideFooter: false,
          title: "Administração - Usuários Logados",
          adminOnly: true
        },
      },
      


      
      {
        path: "AdministracaoLogAuditoria",
        name: "AdministracaoLogAuditoria",
        component: () => import("@/views/administracao/LogAuditoria.vue"),
        meta: { 
          requiresAuth: true, 
          hideFooter: false,
          title: "Administração - Log de Auditoria",
          adminOnly: true
        },
      },
      {
        path: "AdministracaoUsuarios",
        name: "AdministracaoUsuarios",
        component: () => import("@/views/administracao/GestaoUsuarios.vue"),
        meta: { 
          requiresAuth: true, 
          hideFooter: false,
          title: "Administração - Gestão de Usuários",
          adminOnly: true
        },
      },
      {
        path: "AdministracaoConfiguracoes",
        name: "AdministracaoConfiguracoes",
        component: () => import("@/views/administracao/Configuracoes.vue"),
        meta: { 
          requiresAuth: true, 
          hideFooter: false,
          title: "Administração - Configurações",
          adminOnly: true
        },
      },

      {
        path: "/PriorizacaoOrdensDesktop",
        name: "PriorizacaoOrdensDesktop",
        component: () => import("@/views/planejamento/PriorizacaoOrdens.vue"),
        meta: { requiresAuth: true, hideFooter: false, title: "Priorização de Ordens" },
      },

      {
        path: "/PlanejamentoSemanalDesktop",
        name: "PlanejamentoSemanalDesktop",  
        component: () => import("@/views/planejamento/PlanejamentoSemanal.vue"),
        meta: { requiresAuth: true, hideFooter: false, title: "Planejamento Semanal" },
      },

      // ========================================
      // GERENCIAMENTO DE USUÁRIOS E PERMISSÕES
      // ========================================
      {
        path: "GerenciarUsuarios",
        name: "GerenciarUsuarios",
        component: () => import("@/views/permissions/GerenciarUsuarios.vue"),
        meta: { 
          requiresAuth: true, 
          hideFooter: false, 
          title: "Gerenciar Usuários",
          adminOnly: true
        },
      },
      {
        path: "GerenciarGrupos",
        name: "GerenciarGrupos",
        component: () => import("@/views/permissions/GerenciarGrupos.vue"),
        meta: { 
          requiresAuth: true, 
          hideFooter: false, 
          title: "Gerenciar Grupos",
          adminOnly: true
        },
      },
      {
        path: "GerenciarPermissoes/:groupId?",
        name: "GerenciarPermissoes",
        component: () => import("@/views/permissions/GerenciarPermissoes.vue"),
        meta: { 
          requiresAuth: true, 
          hideFooter: false, 
          title: "Gerenciar Permissões",
          adminOnly: true
        },
      },
      {
        path: "GerenciarAplicacoes",
        name: "GerenciarAplicacoes",
        component: () => import("@/views/permissions/GerenciarAplicacoes.vue"),
        meta: { 
          requiresAuth: true, 
          hideFooter: false, 
          title: "Gerenciar Aplicações",
          adminOnly: true
        },
      },
      // ========================================
      // 📊 ROTAS DE RELATÓRIOS
      // ========================================
      {
        path: "RelatorioHorasTrabalhadas",
        name: "RelatorioHorasTrabalhadas",
        component: () => import("@/views/relatorios/RelatorioHorasTrabalhadas.vue"),
        meta: { 
          requiresAuth: true, 
          hideFooter: false, 
          title: "Relatório de Horas Trabalhadas"
        },
      },
      // ✅ ROTAS DE EXPEDIENTE
      {
        path: "FechamentoExpedienteOutroDiaDesktop",
        name: "FechamentoExpedienteOutroDiaDesktop",
        component: () => import("@/views/AberturaExpediente/FechamentoExpedienteOutroDia.vue"),
        meta: { 
          requiresAuth: true, 
          hideFooter: false, 
          title: "Fechamento de Expediente - Outro Dia",
          adminOnly: true
        },
      },
      {
        path: "ExpedienteAlteracaoHorarioManualDesktop",
        name: "ExpedienteAlteracaoHorarioManualDesktop",
        component: () => import("@/views/AberturaExpediente/ExpedienteAlteracaoHorarioManual.vue"),
        meta: { 
          requiresAuth: true, 
          hideFooter: false, 
          title: "Alteração de Horários Manualmente",
          adminOnly: true
        },
      },
    ],
  },
  {
    path: "/LancarProducaoDesktop",
    name: "LancarProducaoDesktop",
    component: () => import("@/views/ordemProducao/lancarProducao.vue"),
    meta: { requiresAuth: true, hideFooter: false, title: "Lançar Produção" },
  },
  { 
    path: '/dashboard-producao',
    name: 'DashboardProducao',
    component: () => import('@/views/ordemProducao/DashboardProducao.vue'),
    meta: {
      title: 'Dashboard de Produção',
      requiresAuth: true
    }
  },


  {
    path: "/ConsultaChamadoMobile",
    name: "ConsultaChamadoMobile",
    component: () => import("@/views/aberturaChamado/ConsultaChamados.vue"),
    meta: { requiresAuth: true, hideFooter: false, title: "Consulta Chamados Mobile" },
  },
  {
    path: "/AberturaExpedienteMobile",
    name: "AberturaExpedienteMobile",
    component: () => import("@/views/AberturaExpediente/AberturaExpediente.vue"),
    meta: { requiresAuth: true, hideFooter: false, title: "Abertura Expediente Mobile" },
  },
  {
    path: "/AberturaExpedienteMenuMobile",
    name: "AberturaExpedienteMenuMobile",
    component: () => import("@/views/AberturaExpediente/MenuOpcoesExpediente.vue"),
    meta: { requiresAuth: true, hideFooter: false, title: "Menu Expediente Mobile" },
  },


  {
    path: "/ConferenciaMaquinaMapaMobile",
    name: "ConferenciaMaquinaMapaMobile",
    component: () => import("@/views/maquinas/ConferenciaMaquinaMapa.vue"),
    meta: { requiresAuth: true, hideFooter: false, title: "Conferência Máquina Mobile" },
  },
  {
    path: "/consultaAparelhosMobile",
    name: "consultaAparelhosMobile",
    component: () => import("@/views/maquinas/ConsultaAparelhos.vue"),
    meta: { requiresAuth: true, hideFooter: false, title: "Consulta Aparelhos Mobile" },
  },
  {
    path: "/ConsultaMaquinasMobile",
    name: "ConsultaMaquinasMobile",
    component: () => import("@/views/maquinas/ConsultaMaquinas.vue"),
    meta: { requiresAuth: true, hideFooter: false, title: "Consulta Máquinas Mobile" },
  },
  {
    path: "/ConsultaQuadroHorarioMobile",
    name: "ConsultaQuadroHorarioMobile",
    component: () => import("@/views/AberturaExpediente/ConsultaQuadroHorario.vue"),
    meta: { requiresAuth: true, hideFooter: false, title: "Quadro Horário Mobile" },
  },
  {
    path: "/VincularAparelhoMobile",
    name: "VincularAparelhoMobile",
    component: () => import("@/views/maquinas/VincularAparelhos.vue"),
    meta: { requiresAuth: true, hideFooter: false, title: "Vincular Aparelho Mobile" },
  },
  {
    path: "/teste",
    name: "teste",
    component: () => import("@/views/MenuTeste.vue"),
    meta: { requiresAuth: true, title: "Teste" },
  },
  // Rota 404
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: PageNotFound,
    meta: { title: "Página não encontrada" }
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

// Variável para controlar se estamos no processo de inicialização
let isInitializing = false;

// Função segura para obter o userStore
function getUserStore() {
  try {
    return useUserStore();
  } catch (error) {
    console.error('💥 Erro ao acessar userStore:', error);
    return {
      isInitialized: false,
      isAuthenticated: false,
      initializeAuth: () => Promise.resolve(false),
      verificarTokenValido: () => Promise.resolve(false),
      needsTokenValidation: false,
      objetoUsuario: null
    };
  }
}

// Guard principal de navegação
router.beforeEach(async (to, from, next) => {
  let userStore;
  
  try {
    userStore = getUserStore();
  } catch (error) {
    console.error(' Erro ao inicializar userStore:', error);
    if (!isPublicRoute(to)) {
      return next({ name: "Login", replace: true });
    }
    return next();
  }
  
  // console.log(` Navegando para: ${to.name} (${to.path})`);
  
  try {
    // 1. VERIFICAÇÃO DE REFRESH/RELOAD DA PÁGINA
    const isPageRefresh = detectPageRefresh();
    
    if (isPageRefresh && !isInitializing) {
      // console.log(' Refresh detectado - verificando sessão...');
      isInitializing = true;
      
      // ✨ MUDANÇA: Usar initializeAuth ao invés de inicializarSessao
      const sessionValid = await userStore.initializeAuth();
      
      if (!sessionValid && !isPublicRoute(to)) {
        // console.log('❌ Sessão inválida após refresh - redirecionando para login');
        isInitializing = false;
        return next({ name: "Login", replace: true });
      }
      
      isInitializing = false;
    }

    // ✨ NOVO: Garantir que a autenticação foi inicializada
    if (!userStore.isInitialized && !isPublicRoute(to)) {
      // console.log('⏳ Aguardando inicialização da autenticação...');
      await userStore.initializeAuth();
    }

    // 2. VERIFICAÇÃO DE ROTAS PÚBLICAS
    if (isPublicRoute(to)) {
      // console.log('🌐 Rota pública - acesso liberado');
      
      // Se já está logado e tenta acessar login, redireciona para menu
      if (to.name === 'Login' && userStore.isAuthenticated) {
        // console.log('✅ Usuário já logado - redirecionando para menu');
        return next({ name: "MenuDefault", replace: true });
      }
      
      return next();
    }

    // 3. VERIFICAÇÃO DE AUTENTICAÇÃO
    if (!userStore.isAuthenticated) {
      // console.log('❌ Usuário não autenticado - redirecionando para login');
      return next({ 
        name: "Login", 
        query: { redirect: to.fullPath },
        replace: true 
      });
    }

    // 4. VERIFICAÇÃO DE TOKEN VÁLIDO (a cada 5 minutos)
    if (userStore.needsTokenValidation) {
      // console.log('🔍 Verificando validade do token...');
      
      const tokenValid = await userStore.verificarTokenValido();
      
      if (!tokenValid) {
        // console.log('❌ Token inválido - redirecionando para login');
        return next({ name: "Login", replace: true });
      }
    }

    // 5. VERIFICAÇÃO DE PERMISSÕES DE ADMIN
    if (requiresAdmin(to)) {
      if (!isAdmin(userStore)) {
        // console.log('❌ Acesso negado - permissões de admin necessárias');
        return next({ name: "MenuDefault", replace: true });
      }
      // console.log('✅ Acesso de admin autorizado');
    }

    // 6. ATUALIZAR TÍTULO DA PÁGINA
    if (to.meta.title) {
      document.title = `${to.meta.title} - Sistema`;
    }

    // console.log('✅ Navegação autorizada');
    next();

  } catch (error) {
    // console.error('💥 Erro no guard de navegação:', error);
    
    // Em caso de erro, redireciona para login por segurança
    if (!isPublicRoute(to)) {
      return next({ name: "Login", replace: true });
    }
    
    next();
  }
});

// Funções auxiliares
function detectPageRefresh() {
  // Múltiplas formas de detectar refresh
  if (performance && performance.navigation) {
    // Tipo 1 = reload/refresh
    return performance.navigation.type === 1;
  }
  
  // Fallback: verificar se é a primeira navegação
  if (performance && performance.getEntriesByType) {
    const navEntries = performance.getEntriesByType('navigation');
    if (navEntries.length > 0) {
      return navEntries[0].type === 'reload';
    }
  }
  
  return false;
}

function isPublicRoute(route) {
  return route.matched.some(record => record.meta.public);
}

function requiresAdmin(route) {
  return route.matched.some(record => record.meta.adminOnly);
}

function isAdmin(userStore) {
  // ✨ MELHORADO: Verificar múltiplas propriedades para admin
  const user = userStore.objetoUsuario;
  if (!user) return false;
  
  return user.admin === true || 
         user.tipo_usuario === 'admin' ||
         user.perfil === 'admin' ||
         user.priv_admin === 'Y' || // ✨ NOVO: baseado no seu retorno do login
         user.role === 'admin';
}

// Guard após navegação (para logs e analytics)
router.afterEach((to, from) => {
  // console.log(`📍 Navegação concluída: ${from.name || 'inicial'} → ${to.name}`);
  
  // Aqui você pode adicionar analytics, logs, etc.
  // analytics.track('page_view', { page: to.name, path: to.path });
});

// Tratamento de erros de navegação
router.onError((error) => {
  console.error('💥 Erro de navegação:', error);
  
  // Você pode implementar um sistema de notificação aqui
  // toast.error('Erro ao navegar. Tente novamente.');
});

export default router;